import {ActionMenuSection} from '#/components/actionmenu/types';
import {InformationTab, PortfolioTab, RentTab, TradeTab} from '#/navigation/tabs';
import {DefaultChildren} from '#/utils/utils';
import {FunctionComponent} from 'react';
import {BooleanParam, QueryParamProvider, StringParam, createEnumParam} from 'use-query-params';
import {ReactRouter6Adapter} from 'use-query-params/adapters/react-router-6';

export const slQueryParamConfigMap = {
  portfolioTabId: createEnumParam(Object.values(PortfolioTab)),
  informationTabId: createEnumParam(Object.values(InformationTab)),
  tradeTabId: createEnumParam(Object.values(TradeTab)),
  rentTabId: createEnumParam(Object.values(RentTab)),
  landToken: StringParam,
  connect: BooleanParam,
  action: createEnumParam(Object.values(ActionMenuSection)),
  actionSource: createEnumParam([ActionMenuSection.INFORMATION]),
  transaction: StringParam,
};
export type SLQueryParamConfig = typeof slQueryParamConfigMap;

export const QueryParamsProvider: FunctionComponent<DefaultChildren> = ({children}) => (
  <QueryParamProvider adapter={ReactRouter6Adapter} options={{params: slQueryParamConfigMap}}>
    {children}
  </QueryParamProvider>
);
